import { fetchAuthSession } from '@aws-amplify/auth';
import { resolveSessionForType } from '../../auth/resolveSession';
export const BLOG_API = 'https://y32k94fh1c.execute-api.us-west-2.amazonaws.com/default/BlogPostHandler';
export const validPost = post => post && ['string','number'].includes(typeof post.id) && typeof post.title === 'string' && typeof post.content === 'string' && typeof post.isPublished === 'boolean';
export function createBlogApi(group) {
  let owner;
  async function request(body, signal) {
    const session = await resolveSessionForType('author', { restore: true, read: fetchAuthSession });
    const token = session.data.tokens?.idToken;
    const sub = token?.payload?.sub;
    if (!token || !sub) throw new Error('Please sign in again with your Author account.');
    if (owner && owner !== sub) throw new Error('Your account changed. Reload this page before editing.');
    owner = sub;
    const response = await fetch(BLOG_API, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token.toString() }, body: JSON.stringify(body), signal });
    let data;
    try { data = await response.json(); } catch { throw new Error('The server did not confirm this request. Your edits are still here. Please reload posts before retrying.'); }
    if (!response.ok) throw Object.assign(new Error(data.error || 'We could not complete this step. Please retry.'), { status: response.status });
    return data;
  }
  return {
    async list(signal) {
      const data = group ? { posts: await group.list(signal), pending: [] } : await request({ action: 'list' }, signal);
      if (!Array.isArray(data.posts) || data.posts.some(p => !validPost(p)) || ((!group || group.versioned) && data.posts.some(p => typeof p.version !== 'string')) || !Array.isArray(data.pending)) throw new Error('Your posts could not be loaded completely. Please retry.');
      return data;
    },
    async save(post) {
      const data = group ? { saved: true, post: (await group.save(post)).item } : await request({ action: 'save', ...post });
      if (data.saved !== true || !validPost(data.post) || String(data.post.id) !== String(post.id) || data.post.isPublished !== post.isPublished || ((!group || group.versioned) && typeof data.post.version !== 'string')) throw new Error('Save was not confirmed. Your edits are still here. Reload posts before retrying.');
      return data;
    },
    async remove(post) {
      const data = group ? await group.remove(group.versioned ? post : post.id) : await request({ action: 'delete', id: String(post.id), version: post.version });
      if (data.deleted !== true) throw new Error('Deletion was not confirmed. Reload posts before retrying.');
      return data;
    },
    async resume(post) { return request({ action: 'resume', id: String(post.id), version: post.version }); },
    async upload(file) {
      if (!['image/png','image/jpeg','image/webp'].includes(file.type) || !file.size || file.size > 2 * 1024 * 1024) throw new Error('Choose a PNG, JPEG, or WebP image up to 2 MB.');
      if (group) return group.upload(file);
      const data = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(String(reader.result).split(',')[1]); reader.onerror = () => reject(new Error('The image could not be read.')); reader.readAsDataURL(file); });
      const result = await request({ action: 'upload', contentType: file.type, data });
      if (typeof result.url !== 'string' || !result.url.startsWith('https://bookish-master-data.s3.us-west-2.amazonaws.com/Public/Images/' + owner + '/Blog/')) throw new Error('Image upload was not confirmed. Please retry.');
      return result.url;
    },
  };
}
